/*!
 * @pixi/filter-hsl-adjustment - v5.3.0
 * Compiled Thu, 15 Feb 2024 16:39:05 UTC
 *
 * @pixi/filter-hsl-adjustment is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import { Filter as o } from "@pixi/core";
var i = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`,
  s = `precision mediump float;

varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float uHue;
uniform float uAlpha;
uniform bool uColorize;
uniform float uSaturation;
uniform float uLightness;

// https://en.wikipedia.org/wiki/Luma_(video)
const vec3 weight = vec3(0.299, 0.587, 0.114);

float getWeightedAverage(vec3 rgb) {
    return rgb.r * weight.r + rgb.g * weight.g + rgb.b * weight.b;
}

// https://gist.github.com/mairod/a75e7b44f68110e1576d77419d608786?permalink_comment_id=3195243#gistcomment-3195243
const vec3 k = vec3(0.57735, 0.57735, 0.57735);

vec3 hueShift(vec3 color, float angle) {
    float cosAngle = cos(angle);
    return vec3(
    color * cosAngle +
    cross(k, color) * sin(angle) +
    k * dot(k, color) * (1.0 - cosAngle)
    );
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    vec4 result = color;

    // colorize
    if (uColorize) {
        result.rgb = vec3(getWeightedAverage(result.rgb), 0., 0.);
    }

    // hue
    result.rgb = hueShift(result.rgb, uHue);

    // saturation
    // https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/huesaturation.js
    float average = (result.r + result.g + result.b) / 3.0;

    if (uSaturation > 0.) {
        result.rgb += (average - result.rgb) * (1. - 1. / (1.001 - uSaturation));
    } else {
        result.rgb -= (average - result.rgb) * uSaturation;
    }

    // lightness
    result.rgb = mix(result.rgb, vec3(ceil(uLightness)) * color.a, abs(uLightness));

    // alpha
    gl_FragColor = mix(color, result, uAlpha);
}
`;
const t = class extends o {
  constructor(e) {
    super(i, s), this._hue = 0;
    const r = Object.assign({}, t.defaults, e);
    Object.assign(this, r);
  }
  get hue() {
    return this._hue;
  }
  set hue(e) {
    this._hue = e, this.uniforms.uHue = this._hue * (Math.PI / 180);
  }
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(e) {
    this.uniforms.uAlpha = e;
  }
  get colorize() {
    return this.uniforms.uColorize;
  }
  set colorize(e) {
    this.uniforms.uColorize = e;
  }
  get lightness() {
    return this.uniforms.uLightness;
  }
  set lightness(e) {
    this.uniforms.uLightness = e;
  }
  get saturation() {
    return this.uniforms.uSaturation;
  }
  set saturation(e) {
    this.uniforms.uSaturation = e;
  }
};
let n = t;
n.defaults = {
  hue: 0,
  saturation: 0,
  lightness: 0,
  colorize: !1,
  alpha: 1
};
export { n as HslAdjustmentFilter };
